/* CUSTOM IFB — Pagina del look "Shop the Look" (sections/ifb-shop-the-look.liquid)
   Selezione dei capi, scelta taglia, totale e aggiunta multipla al carrello
   (stesso flusso di product-form.js: cart/add.js + renderContents di cart-drawer / cart-notification). */

if (!customElements.get('ifb-shop-the-look')) {
  // Testi di riserva (italiano): quelli tradotti arrivano dalla sezione in <script type="application/json" data-ifb-i18n>
  // (chiavi ifb.looks.* dei file locales/). {count} è un segnaposto.
  const IFB_LOOK_FALLBACK = {
    selected_one: '1 capo selezionato',
    selected_other: '{count} capi selezionati',
    added: 'Aggiunto!',
    error: 'Si è verificato un errore. Riprova.',
  };

  class IfbShopTheLook extends HTMLElement {
    // Testo tradotto con i segnaposto {nome} sostituiti
    t(key, vars = {}) {
      const str = this.strings[key] ?? IFB_LOOK_FALLBACK[key] ?? key;
      return str.replace(/\{(\w+)\}/g, (all, name) => (name in vars ? vars[name] : all));
    }

    connectedCallback() {
      this.strings = {};
      try {
        const data = JSON.parse(this.querySelector('script[data-ifb-i18n]')?.textContent || '{}');
        // il filtro | t di Shopify può restituire entità HTML (es. &#39;): le riconverto in testo
        const decoder = document.createElement('textarea');
        Object.keys(data).forEach((k) => {
          if (typeof data[k] !== 'string') return;
          decoder.innerHTML = data[k];
          this.strings[k] = decoder.value;
        });
      } catch (e) {
        // testi di riserva in italiano
      }

      this.items = Array.from(this.querySelectorAll('.ifb-look__item'));
      this.button = this.querySelector('.ifb-look__add');
      this.count = this.querySelector('.ifb-look__add-count');
      this.total = this.querySelector('.ifb-look__total-amount');
      this.totalCount = this.querySelector('.ifb-look__total-count');
      this.label = this.querySelector('.ifb-look__add-label');
      this.error = this.querySelector('.ifb-look__error');

      this.addEventListener('change', (event) => {
        if (event.target.matches('.ifb-look__variant')) this.updatePrice(event.target);
        this.update();
      });

      if (!this.button) return;
      this.button.addEventListener('click', () => this.addToCart());

      this.update();
    }

    selectedItems() {
      return this.items.filter((item) => {
        const checkbox = item.querySelector('.ifb-look__checkbox');
        return checkbox && checkbox.checked && !checkbox.disabled && item.querySelector('.ifb-look__variant');
      });
    }

    variantData(item) {
      const input = item.querySelector('.ifb-look__variant');
      const source = input.tagName === 'SELECT' ? input.selectedOptions[0] : input;
      return { id: parseInt(input.value, 10), price: parseInt(source.dataset.price, 10) || 0 };
    }

    updatePrice(select) {
      const item = select.closest('.ifb-look__item');
      const option = select.selectedOptions[0];
      const price = parseInt(option.dataset.price, 10) || 0;
      const compare = parseInt(option.dataset.compare, 10) || 0;
      const compareEl = item.querySelector('.ifb-look__price-compare');

      item.querySelector('.ifb-look__price-current').textContent = this.formatMoney(price);
      compareEl.hidden = compare <= price;
      if (compare > price) compareEl.textContent = this.formatMoney(compare);
    }

    update() {
      const selected = this.selectedItems();
      const sum = selected.reduce((acc, item) => acc + this.variantData(item).price, 0);

      this.items.forEach((item) => {
        const checkbox = item.querySelector('.ifb-look__checkbox');
        item.classList.toggle('is-unselected', !checkbox || !checkbox.checked);
      });

      this.total.textContent = this.formatMoney(sum);
      this.count.textContent = selected.length || '';
      this.count.hidden = selected.length === 0;
      this.totalCount.textContent =
        selected.length === 1 ? this.t('selected_one') : this.t('selected_other', { count: selected.length });
      this.button.setAttribute('aria-label', `${this.label.dataset.default} (${selected.length})`);
      this.button.disabled = selected.length === 0;
      this.hideError();
    }

    addToCart() {
      const items = this.selectedItems().map((item) => ({ id: this.variantData(item).id, quantity: 1 }));
      if (!items.length) return;

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const sections = cart ? cart.getSectionsToRender().map((s) => s.id) : [];
      if (cart && cart.setActiveElement) cart.setActiveElement(this.button);
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      this.button.disabled = true;
      this.button.classList.add('is-loading');
      this.hideError();

      fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections, sections_url: window.location.pathname }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.showError(response.description || response.message);
            return;
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ifb-shop-the-look', cartData: response });
          }

          this.showAdded();

          if (cart && response.sections) {
            // con più articoli la risposta è { items, sections }: la notifica vuole la key di un articolo
            cart.renderContents({ ...response, key: response.key || (response.items && response.items[0].key) });
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || `${root}cart`;
          }
        })
        .catch(() => this.showError(this.t('error')))
        .finally(() => {
          this.button.classList.remove('is-loading');
          this.button.disabled = this.selectedItems().length === 0;
        });
    }

    showAdded() {
      this.button.classList.add('is-added');
      this.label.textContent = this.t('added');
      clearTimeout(this.addedTimer);
      this.addedTimer = setTimeout(() => {
        this.button.classList.remove('is-added');
        this.label.textContent = this.label.dataset.default;
      }, 2200);
    }

    showError(message) {
      this.error.textContent = message;
      this.error.hidden = false;
    }

    hideError() {
      this.error.hidden = true;
      this.error.textContent = '';
    }

    formatMoney(cents) {
      const format = this.dataset.moneyFormat || '€{{amount_with_comma_separator}}';
      const group = (value, decimals, thousands, decimal) => {
        const [int, dec] = (value / 100).toFixed(decimals).split('.');
        return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (dec ? decimal + dec : '');
      };

      return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
        switch (key) {
          case 'amount_no_decimals':
            return group(cents, 0, ',', '.');
          case 'amount_with_comma_separator':
            return group(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator':
            return group(cents, 0, '.', ',');
          case 'amount_with_apostrophe_separator':
            return group(cents, 2, "'", '.');
          default:
            return group(cents, 2, ',', '.');
        }
      });
    }
  }

  customElements.define('ifb-shop-the-look', IfbShopTheLook);
}
